import { Link } from "react-router-dom";
import { ShieldCheck, Landmark, Mail, FileText } from "lucide-react";
import { COMPANY } from "@/data/company";

/**
 * BrokerSignup (`/for-brokers`) — FROZEN.
 *
 * Legacy CMA/MoE institutional self-serve signup has been retired as part of
 * the Obondo consolidation. New institutional/API access now goes through the
 * upcoming Application Form (Part 4). Existing agencies are unaffected and
 * continue to log in normally via /login.
 */
export default function BrokerSignup() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <header className="border-b border-border">
                <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
                    <Link to="/" className="font-extrabold tracking-tight text-lg" data-testid="broker-signup-frozen-logo">
                        Melian Dialogue
                    </Link>
                    <div className="text-xs text-muted-foreground flex items-center gap-2">
                        <ShieldCheck className="w-3.5 h-3.5 text-accent" />
                        Institutional access
                    </div>
                </div>
            </header>

            <div className="max-w-2xl mx-auto px-4 py-16 md:py-24 text-center" data-testid="broker-signup-frozen-notice">
                <div className="mx-auto mb-6 w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                    <Landmark className="w-6 h-6 text-primary" />
                </div>
                <div className="text-xs uppercase tracking-widest text-primary font-semibold mb-3">
                    Institutional signup
                </div>
                <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4">
                    We're upgrading institutional signup
                </h1>
                <p className="text-muted-foreground leading-relaxed mb-8">
                    Self-serve institutional registration is temporarily closed while we roll out a new
                    application process. If you'd like to bring your organisation onto Melian Dialogue,
                    apply for API access and our team will set you up.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <Link
                        to="/apply"
                        data-testid="broker-signup-apply-button"
                        className="inline-flex items-center gap-2 px-6 py-3 rounded bg-primary text-primary-foreground font-semibold text-sm hover:opacity-90 transition-opacity"
                    >
                        <FileText className="w-4 h-4" />
                        Apply for API access
                    </Link>
                    <a
                        href={`mailto:${COMPANY.email_billing}`}
                        data-testid="broker-signup-contact-us-button"
                        className="inline-flex items-center gap-2 px-6 py-3 rounded border border-border font-semibold text-sm hover:bg-muted/40 transition-colors"
                    >
                        <Mail className="w-4 h-4" />
                        Contact us
                    </a>
                </div>

                <div className="text-xs text-center text-muted-foreground mt-8">
                    Already have an account? <Link to="/login" data-testid="broker-signup-frozen-login-link" className="text-primary hover:underline">Sign in</Link>
                </div>
            </div>
        </div>
    );
}
